import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { paymentModeLabel } from "./addMoneyUtils";

// GET /policyWallet mixes the user's own top-up requests with money the admin
// added directly; only the latter carry type "ADMIN_TOPUP".
export const isAdminTopup = (row) => row?.type === "ADMIN_TOPUP";

/** "Top-up request" or "Added by admin" (details in a tooltip) for a wallet list row. */
const TopupSource = ({ row }) => {
  if (!isAdminTopup(row)) return <Typography>Top-up request</Typography>;

  const details = [
    ["Payment mode", row.paymentMode ? paymentModeLabel(row.paymentMode) : ""],
    ["Reference", row.reference],
    ["Remarks", row.remarks],
  ].filter(([, value]) => value);

  return (
    <Tooltip
      arrow
      title={
        <Box sx={{ fontFamily: "Inter", fontSize: "12px", maxWidth: 260 }}>
          <div>Added by {row.addedByName || "admin"}</div>
          {details.map(([label, value]) => (
            <div key={label}>
              {label}: {value}
            </div>
          ))}
        </Box>
      }
    >
      <Typography
        tabIndex={0}
        sx={{
          width: "fit-content",
          color: "#1E3A5F",
          fontWeight: 500,
          cursor: "help",
          borderBottom: "1px dotted #98A2B3",
        }}
      >
        Added by admin
      </Typography>
    </Tooltip>
  );
};

export default TopupSource;
